// extracted by mini-css-extract-plugin
export default {"root":"WidgetType1_root__V9PB7","widgetHeader":"WidgetType1_widgetHeader__l0XYZ","widgetContent":"WidgetType1_widgetContent__sMmFv"};